import { library } from '@fortawesome/fontawesome-svg-core';
import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

import {
    faBuilding as falBuilding,
    faMobile as falMobile,
    faSquare as falSquare,
    faThumbsUp as falThumbsUp,
    faComment as falComment,
    faTimesCircle as falTimesCircle,
    faPlay as falPlay,
    faPause as falPause,
    faCommentSlash as falCommentSlash,
    faSync as falSync,
    faClock as falClock,
    faBracketsCurly as falBracketsCurly,
    faCheck as falCheck,
    faCalendar as falCalendar,
    faPencil as falPencil,
    faChevronLeft as falChevronLeft,
    faClone as falClone,
    faPhoneAlt as falPhoneAlt,
    faSearch as falSearch,
    faUsdCircle as falUsdCircle,
    faTimes as falTimes,
    faUsersSlash as falUsersSlash,
    faCheckSquare as falCheckSquare,
    faVideo as falVideo,
    faPaperclip as falPaperclip,
    faClipboard as falClipboard,
    faArrowToBottom as falArrowToBottom,
    faVolumeOff as falVolumeOff,
    faVolumeDown as falVolumeDown,
    faVolume as falVolume,
    faVolumeUp as falVolumeUp,
    faExpand as falExpand,
    faPen as falPen,
    faMicrophone as falMicrophone,
    faStop as falStop,
    faAngleUp as falAngleUp,
    faAngleDown as falAngleDown,
    faPenSquare as falPenSquare,
    faMinusOctagon as falMinusOctagon,
    faEdit as falEdit,
    faCloudUploadAlt as farCloudUploadAltL,
    faArrowLeft as falArrowLeft,
    faArrowRight as falArrowRight,
    faArrowUp as falArrowUp,
    faArrowDown as falArrowDown,
    faRedo as falRedo,
    faShareAlt as falShareAlt,
    faAngleLeft as falAngleLeft,
    faUsersCrown as falUsersCrown,
} from '@fortawesome/pro-light-svg-icons';

import {
    faBan as farBan,
    faBullhorn as farBullhorn,
    faCalendar as farCalendar,
    faCheck as farCheck,
    faCheckCircle as farCheckCircle,
    faCircleNotch as farCircleNotch,
    faClipboard as farClipboard,
    faCloudUploadAlt as farCloudUploadAlt,
    faCoins as farCoins,
    faComment as farComment,
    faCommentDots as farCommentDots,
    faComments as farComments,
    faExpand as farExpand,
    faFileExcel as farFileExcel,
    faHistory as farHistory,
    faImages as farImages,
    faListAlt as farListAlt,
    faLock as farLock,
    faMinusCircle as farMinusCircle,
    faPaperPlane as farPaperPlane,
    faPlus as farPlus,
    faQuestionCircle as farQuestionCircle,
    faSearch as farSearch,
    faShare as farShare,
    faSmile as farSmile,
    faStar as farStar,
    faSyncAlt as farSyncAlt,
    faTimes as farTimes,
    faUser as farUser,
    faUsers as farUsers,
    faUserSecret as farUserSecret,
    faLightbulbOn as farLightbulbOn,
    faTimesCircle as farTimesCircle,
    faPlay as farPlay,
    faPause as farPause,
    faCommentSlash as farCommentSlash,
    faSync as farSync,
    faClock as farClock,
    faBracketsCurly as farBracketsCurly,
    faPencil as farPencil,
    faChevronLeft as farChevronLeft,
    faClone as farClone,
    faPhoneAlt as farPhoneAlt,
    faAngleRight as farAngleRight,
    faAngleLeft as farAngleLeft,
    faArrowLeft as farArrowLeft,
    faArrowRight as farArrowRight,
    faUsdCircle as farUsdCircle,
    faUsersSlash as farUsersSlash,
    faCheckSquare as farCheckSquare,
    faVideo as farVideo,
    faPaperclip as farPaperclip,
    faArrowUp as farArrowUp,
    faArrowToBottom as farArrowToBottom,
    faVolumeOff as farVolumeOff,
    faVolumeDown as farVolumeDown,
    faVolume as farVolume,
    faVolumeUp as farVolumeUp,
    faPen as farPen,
    faMicrophone as farMicrophone,
    faStop as farStop,
    faAngleUp as farAngleUp,
    faAngleDown as farAngleDown,
    faPenSquare as farPenSquare,
    faMinusOctagon as farMinusOctagon,
    faEdit as farEdit,
    faRedo as farRedo,
    faShareAlt as farShareAlt,
    faUsersCrown as farUsersCrown,
} from '@fortawesome/pro-regular-svg-icons';

import {
    faAddressBook as fasAddressBook,
    faAnalytics as fasAnalytics,
    faAngleUp as fasAngleUp,
    faAngleDown as fasAngleDown,
    faAngleLeft as fasAngleLeft,
    faAngleRight as fasAngleRight,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
    faBan as fasBan,
    faBolt as fasBolt,
    faBuilding as fasBuilding,
    faCaretDown as fasCaretDown,
    faCaretUp as fasCaretUp,
    faCheck as fasCheck,
    faCheckCircle as fasCheckCircle,
    faCheckSquare as fasCheckSquare,
    faCircleNotch as fasCircleNotch,
    faClipboard as fasClipboard,
    faClipboardCheck as fasClipboardCheck,
    faCoins as fasCoins,
    faComment as fasComment,
    faCreditCard as fasCreditCard,
    faCommentExclamation as fasCommentExclamation,
    faComments as fasComments,
    faCog as fasCog,
    faCopy as fasCopy,
    faCubes as fasCubes,
    faDownload as fasDownload,
    faEnvelope as fasEnvelope,
    faExclamation as fasExclamation,
    faExclamationCircle as fasExclamationCircle,
    faExclamationTriangle as fasExclamationTriangle,
    faExternalLink as fasEternalLink,
    faForward as fasForward,
    faGift as fasGift,
    faGlobe as fasGlobe,
    faHistory as fasHistory,
    faHome as fasHome,
    faHourglassHalf as fasHourglassHalf,
    faInbox as fasInbox,
    faInboxIn as fasInboxIn,
    faInboxOut as fasInboxOut,
    faInfoCircle as fasInfoCircle,
    faKey as fasKey,
    faLink as fasLink,
    faMinusCircle as fasMinusCircle,
    faMinusSquare as fasMinusSquare,
    faMobileAlt as fasMobileAlt,
    faPencil as fasPencil,
    faPhone as fasPhone,
    faPlug as fasPlug,
    faPlus as fasPlus,
    faPlusCircle as fasPlusCircle,
    faPlusSquare as fasPlusSquare,
    faQuestion as fasQuestion,
    faQuestionCircle as fasQuestionCircle,
    faRedo as fasRedo,
    faReply as fasReply,
    faSearch as fasSearch,
    faShield as fasShield,
    faSignInAlt as fasSignInAlt,
    faSignOut as fasSignOut,
    faSpaceShuttle as fasSpaceShuttle,
    faSpinnerThird as fasSpinnerThird,
    faStar as fasStar,
    faSyncAlt as fasSyncAlt,
    faTag as fasTag,
    faTags as fasTags,
    faTasks as fasTasks,
    faTimes as fasTimes,
    faToolbox as fasToolbox,
    faTrash as fasTrash,
    faUnlink as fasUnlink,
    faUnlock as fasUnlock,
    faUser as fasUser,
    faUserNinja as fasUserNinja,
    faUsers as fasUsers,
    faUserAlt as fasUserAlt,
    faUserSecret as fasUserSecret,
    faWrench as fasWrench,
    faLightbulbOn as fasLightbulbOn,
    faTimesCircle as fasTimesCircle,
    faPlay as fasPlay,
    faPause as fasPause,
    faCommentSlash as fasCommentSlash,
    faSync as fasSync,
    faClock as fasClock,
    faBracketsCurly as fasBracketsCurly,
    faCalendar as fasCalendar,
    faChevronLeft as fasChevronLeft,
    faClone as fasClone,
    faImages as fasImages,
    faCommentAltPlus as fasCommentAltPlus,
    faPhoneAlt as fasPhoneAlt,
    faUserSlash as fasUserSlash,
    faUsdCircle as fasUsdCircle,
    faUsersSlash as fasUsersSlash,
    faLock as fasLock,
    faVideo as fasVideo,
    faPaperclip as fasPaperclip,
    faArrowUp as fasArrowUp,
    faArrowToBottom as fasArrowToBottom,
    faVolumeOff as fasVolumeOff,
    faVolumeDown as fasVolumeDown,
    faVolume as fasVolume,
    faVolumeUp as fasVolumeUp,
    faExpand as fasExpand,
    faPen as fasPen,
    faMicrophone as fasMicrophone,
    faStop as fasStop,
    faPenSquare as fasPenSquare,
    faMinusOctagon as fasMinusOctagon,
    faEdit as fasEdit,
    faArrowCircleUp as fasArrowCircleUp,
    faShareAlt as fasShareAlt,
    faUsersCrown as fasUsersCrown,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faGoogle as fabGoogle,
    faWindows as fabWindows,
    faFacebookF as fabFacebookF,
    faTwitter as fabTwitter,
    faLinkedinIn as fabLinkedinIn,
    faHubspot as fabHubspot,
} from '@fortawesome/free-brands-svg-icons';

export const FontAwesomeComponents = (Vue) => {
    Vue.component('font-awesome-icon', FontAwesomeIcon);
    Vue.component('font-awesome-layers', FontAwesomeLayers);
    Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
};

library.add(
    // Light
    falBuilding,
    falMobile,
    falSquare,
    falThumbsUp,
    falComment,
    falTimesCircle,
    falPlay,
    falCommentSlash,
    falSync,
    falClock,
    falBracketsCurly,
    falCheck,
    falCalendar,
    falPencil,
    falChevronLeft,
    falClone,
    falPhoneAlt,
    falSearch,
    falUsdCircle,
    falTimes,
    falUsersSlash,
    falCheckSquare,
    falVideo,
    falPause,
    falPaperclip,
    falArrowUp,
    falArrowToBottom,
    falVolumeOff,
    falVolumeDown,
    falVolume,
    falVolumeUp,
    falExpand,
    falPen,
    falMicrophone,
    falStop,
    falAngleUp,
    falAngleDown,
    falPenSquare,
    falMinusOctagon,
    falEdit,
    farCloudUploadAltL,
    falArrowLeft,
    falArrowRight,
    falArrowDown,
    falRedo,
    falShareAlt,
    falAngleLeft,
    falUsersCrown,

    // Regular
    farBan,
    farBullhorn,
    farCalendar,
    farCheck,
    farCheckCircle,
    farCircleNotch,
    farClipboard,
    falClipboard,
    farClock,
    farCloudUploadAlt,
    farCoins,
    farComment,
    farCommentDots,
    farComments,
    farExpand,
    farFileExcel,
    farHistory,
    farImages,
    farListAlt,
    farLock,
    farMinusCircle,
    farPaperPlane,
    farPlus,
    farQuestionCircle,
    farSearch,
    farShare,
    farSmile,
    farStar,
    farSyncAlt,
    farTimes,
    farUser,
    farUsers,
    farUserSecret,
    farLightbulbOn,
    farTimesCircle,
    farPlay,
    farCommentSlash,
    farSync,
    farClock,
    farBracketsCurly,
    farPencil,
    farChevronLeft,
    farClone,
    farPhoneAlt,
    farAngleRight,
    farAngleLeft,
    farArrowLeft,
    farArrowRight,
    farUsdCircle,
    farUsersSlash,
    farCheckSquare,
    farVideo,
    farPause,
    farPaperclip,
    farArrowUp,
    farArrowToBottom,
    farVolumeOff,
    farVolumeDown,
    farVolume,
    farVolumeUp,
    farPen,
    farMicrophone,
    farStop,
    farAngleUp,
    farAngleDown,
    farPenSquare,
    farMinusOctagon,
    farEdit,
    farRedo,
    farShareAlt,
    farUsersCrown,

    // Solid
    fasArrowCircleUp,
    fasAddressBook,
    fasAnalytics,
    fasAngleUp,
    fasAngleDown,
    fasAngleLeft,
    fasAngleRight,
    fasArrowLeft,
    fasArrowRight,
    fasBan,
    fasBolt,
    fasBuilding,
    fasCaretDown,
    fasCaretUp,
    fasCheck,
    fasCheckCircle,
    fasCheckSquare,
    fasCircleNotch,
    fasClipboard,
    fasClipboardCheck,
    fasCoins,
    fasComment,
    fasCreditCard,
    fasCommentExclamation,
    fasComments,
    fasCog,
    fasCopy,
    fasCubes,
    fasDownload,
    fasEnvelope,
    fasExclamation,
    fasExclamationCircle,
    fasExclamationTriangle,
    fasEternalLink,
    fasForward,
    fasGift,
    fasGlobe,
    fasHistory,
    fasHome,
    fasHourglassHalf,
    fasInbox,
    fasInboxIn,
    fasInboxOut,
    fasInfoCircle,
    fasKey,
    fasLink,
    fasMinusCircle,
    fasMinusSquare,
    fasMobileAlt,
    fasPencil,
    fasPhone,
    fasPlug,
    fasPlus,
    fasPlusCircle,
    fasPlusSquare,
    fasQuestion,
    fasQuestionCircle,
    fasRedo,
    fasReply,
    fasSearch,
    fasShield,
    fasSignInAlt,
    fasSignOut,
    fasSpaceShuttle,
    fasSpinnerThird,
    fasStar,
    fasSyncAlt,
    fasTag,
    fasTags,
    fasTasks,
    fasTimes,
    fasToolbox,
    fasTrash,
    fasUnlink,
    fasUnlock,
    fasUser,
    fasUserNinja,
    fasUsers,
    fasUserAlt,
    fasUserSecret,
    fasWrench,
    fasLightbulbOn,
    fasTimesCircle,
    fasPlay,
    fasCommentSlash,
    fasSync,
    fasClock,
    fasBracketsCurly,
    fasCalendar,
    fasPencil,
    fasChevronLeft,
    fasClone,
    fasImages,
    fasCommentAltPlus,
    fasPhoneAlt,
    fasUserSlash,
    fasUsdCircle,
    fasUsersSlash,
    fasLock,
    fasVideo,
    fasPause,
    fasPaperclip,
    fasArrowUp,
    fasArrowToBottom,
    fasVolumeOff,
    fasVolumeDown,
    fasVolume,
    fasVolumeUp,
    fasExpand,
    fasPen,
    fasMicrophone,
    fasStop,
    fasPenSquare,
    fasMinusOctagon,
    fasEdit,
    fasShareAlt,
    fasUsersCrown,

    // Brands
    fabGoogle,
    fabWindows,
    fabFacebookF,
    fabTwitter,
    fabLinkedinIn,
    fabHubspot
);
